import React, { useContext } from 'react';
import { BlockHeader, Image } from '../../components';
import { LocationContext } from '../../context/locationContext';
import { block, getLinkProps } from '../../utils';
import './Icons.css';
const b = block('icons-block');
const Icons = ({ title, size = 's', items }) => {
    const { hostname } = useContext(LocationContext);
    return (React.createElement("div", { className: b({ size }) },
        title && React.createElement(BlockHeader, { className: b('header'), title: title, colSizes: { all: 12 } }),
        items.map((item) => (React.createElement("a", Object.assign({ className: b('item'), key: item.url, href: item.url }, getLinkProps(item.url, hostname)),
            React.createElement(Image, { className: b('image'), src: item.src }),
            React.createElement("p", { className: b('text') }, item.text))))));
};
export default Icons;
